function ConvencoesColetivas() {
    return 'ConvencoesColetivas'
}

export default ConvencoesColetivas